import { render } from "./WhatIDo.vue?vue&type=template&id=63ff8579"
import script from "./WhatIDo.vue?vue&type=script&lang=js"
export * from "./WhatIDo.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__